define([
    "jquery",
    "underscore",
    "marionette",
    "holdon"
], function($, _, Marionette) {
    return Marionette.View.extend({
        el: '#content_layout',

        ui: {
            'optinableAccountDropdown': '#optinable-account-dropdown',
            'optInBtn': '#opt-in-btn',

            'optInModal': '#opt-in-modal',
            'optInModalTitle': '#opt-in-modal-title',
            'optInModalDesc': '#opt-in-modal-desc',
            'optInModalBtn': '#opt-in-modal-btn',

            'downloadTermsAndConditionsBtn': '.download_terms_and_condition_btn',

            'accountHistoryDropdown': '#account-history-dropdown',
            'monthDropdown': '#month-dropdown',

            'cashbackTableTbody': '#cashback-table-tbody',

            'paginationContainer': '#pagination-container',
            'paginationRowInfo': '#pagination-row-info',
            'paginationPrevBtn': '#pagination-prev-btn',
            'paginationNextBtn': '#pagination-next-btn',
            'paginationLimit': '#pagination-limit',
            'paginationOffset': '#pagination-offset',
        },

        events: {
            'click @ui.optInBtn': 'optIn',

            'click @ui.optInModalBtn': 'refreshPage',

            'click @ui.downloadTermsAndConditionsBtn': 'downloadTermsAndConditions',

            'change @ui.accountHistoryDropdown': 'getCashbackHistories',
            'change @ui.monthDropdown': 'getCashbackHistories',

            'click @ui.paginationPrevBtn': 'getCashbackHistories',
            'click @ui.paginationNextBtn': 'getCashbackHistories',
        },

        initialize: function()
        {
            this.bindUIElements();
        },

        optIn: function(e)
        {
            e.preventDefault();

            HoldOn.open({ theme:"sk-fading-circle" });

            if(window.promotional_event_id == 'cashback_vietnam') {
                const mt4AccountNo = this.ui.optinableAccountDropdown.val()
                this.requestOptIn(mt4AccountNo, window.promotional_event_id);
            } else {
                this.requestOptIn(window.mt4_account_no, window.promotional_event_id);
            }
        },

        refreshPage: function(e)
        {
            e.preventDefault();
            location.reload();
        },

        downloadTermsAndConditions: function(e)
        {
            e.preventDefault();
            window.open(window.terms_and_conditions_url, '_blank');
        },

        injectOptInModalMessage: function(modalMessageData)
        {
            this.ui.optInModalTitle.text(modalMessageData.title);
            this.ui.optInModalDesc.html(modalMessageData.desc);
        },

        requestOptIn: function(mt4_account_no, promotional_event_id)
        {
            const that = this;

            $.ajax({
                url: '/rest_promotional_event/optin',
                type: 'POST',
                data: { mt4_account_no, promotional_event_id },
                dataType: 'json',
                success: function(data)
                {
                    that.injectOptInModalMessage(data.modal_message);
                    that.ui.optInModal.modal('show');

                },
                complete: function()
                {
                    HoldOn.close();
                }
            })
        },

        getCashbackHistories: function(e)
        {
            e.preventDefault();

            HoldOn.open({ theme:"sk-fading-circle" });

            let mt4_account_no;
            if(window.promotional_event_id == 'cashback_vietnam') {
                mt4_account_no = window.optin_account_no
            } else {
                mt4_account_no = this.ui.accountHistoryDropdown.val();
            }
            const date = this.ui.monthDropdown.val();

            let limit = Number(this.ui.paginationLimit.val());
            if(!limit) {
                limit = 10;
            }
            let offset = Number(this.ui.paginationOffset.val());
            if(!offset) {
                offset = 0
            }

            const trigger_id = $(e.target).attr('id');
            offset = (trigger_id === 'pagination-next-btn') ? offset + limit : offset - limit;

            const trigger_class = $(e.target).attr('class');
            offset = (trigger_class === 'cashback-dropdown') ? 0 : offset;

            this.requestCashbackHistories(mt4_account_no, date, limit, offset);
        },

        requestCashbackHistories: function(mt4_account_no, date, limit, offset)
        {
            const promotional_event_id = window.promotional_event_id

            const that = this;

            $.ajax({
                url: '/rest_promotional_event/cashback_histories',
                type: 'GET',
                data: { mt4_account_no, date, limit, offset, promotional_event_id },
                success: function(data)
                {
                    if(promotional_event_id == 'cashback_japan') {
                        that.renderCashbackJapanTable(data.cashback_histories, data.member_currency);
                    }
                    else {
                        that.renderCashbackTable(data.cashback_histories);
                    }
                    that.renderPaginationInfo(data.pagination_info);
                },
                complete: function()
                {
                    HoldOn.close();
                }
            })
        },

        renderPaginationInfo: function(paginationInfo)
        {
            const paginationRowInfo = `${paginationInfo.row_count_begin} - ${paginationInfo.row_count_end} / ${paginationInfo.row_count_total}`;
            this.ui.paginationRowInfo.text(paginationRowInfo);

            if(paginationInfo.has_prev)
            {
                this.ui.paginationPrevBtn.prop('hidden', false);
            }
            else
            {
                this.ui.paginationPrevBtn.prop('hidden', true);
            }

            if(paginationInfo.has_next)
            {
                this.ui.paginationNextBtn.prop('hidden', false);
            }
            else
            {
                this.ui.paginationNextBtn.prop('hidden', true);
            }

            this.ui.paginationLimit.val(paginationInfo.limit);
            this.ui.paginationOffset.val(paginationInfo.offset);
        },

        renderCashbackTable: function(cashbackHistories) {

            this.ui.cashbackTableTbody.empty();

            let html = "";

            cashbackHistories.forEach(cashback => {
                const specials = ['special_3', 'special_2', 'special_1'];

                let accountType = cashback.member_type_name.charAt(0).toUpperCase() + cashback.member_type_name.slice(1);
                if (specials.includes(cashback.member_type_name)) {
                    accountType = 'Standard';
                }

                html += "<tr>";
                html += `<td>${cashback.reg_date}</td>`;
                html += `<td>${cashback.mt4_account_no}</td>`;
                html += `<td>${accountType}</td>`;
                html += `<td>${cashback.lots}</td>`;
                html += `<td>${cashback.usd_per_lot}</td>`;
                html += `<td>${cashback.cashback}</td>`;
                html += `</tr>`;
            });

            this.ui.cashbackTableTbody.append(html);
        },

        renderCashbackJapanTable: function(cashbackHistories, memberCurrency) {

            this.ui.cashbackTableTbody.empty();

            let html = "";

            cashbackHistories.forEach(cashback => {
                const cashbackType = cashback.memo == 'deposit' ? '入金' : '取引';
                const lots = cashback.memo == 'deposit' ? '-' : cashback.lots;
                const usdPerLot = cashback.memo == 'deposit' ? '-' : `\$${cashback.usd_per_lot}`;

                html += "<tr>";
                html += `<td>${cashback.reg_date}</td>`;
                html += `<td>${cashback.mt4_account_no}</td>`;
                html += `<td>${cashbackType}</td>`;
                html += `<td>${lots}</td>`;
                html += `<td>${usdPerLot}</td>`;
                html += `<td>${memberCurrency.currency_symbol}${memberCurrency.currency_cd == 3 ? parseInt(cashback.cashback) : cashback.cashback}</td>`;
                html += `</tr>`;
            });

            this.ui.cashbackTableTbody.append(html);
        },
    });
});